import axios from "../api";
import { useCallback } from "react";

import useAuth from "./use-auth.js";

// Holds the in-flight /refresh promise so concurrent callers (axios interceptor,
// PersistLogin) share one request instead of triggering parallel /refresh calls.
const refreshState = { pending: null };

function useRefreshToken() {
  const { buildAndSetAuth } = useAuth();

  return useCallback(
    function refresh() {
      if (!refreshState.pending) {
        refreshState.pending = axios
          .get("/refresh")
          .then((response) => {
            buildAndSetAuth(response.data);
            return response.data.access_token;
          })
          .finally(() => {
            refreshState.pending = null;
          });
      }
      return refreshState.pending;
    },
    [buildAndSetAuth],
  );
}

export default useRefreshToken;
